var map = {
	"./AddSquareBold.svg": [
		7107,
		7107
	],
	"./AddSquareRegular.svg": [
		87635,
		87635
	],
	"./AlertBold.svg": [
		40463,
		40463
	],
	"./AlertRegular.svg": [
		66548,
		66548
	],
	"./AnnounceBold.svg": [
		63360,
		63360
	],
	"./AnnounceRegular.svg": [
		51804,
		51804
	],
	"./Apartment2Bold.svg": [
		50258,
		50258
	],
	"./Apartment2Regular.svg": [
		25370,
		25370
	],
	"./ApartmentBold.svg": [
		39111,
		39111
	],
	"./ApartmentRegular.svg": [
		29485,
		29485
	],
	"./ArrowDownBold.svg": [
		73296,
		73296
	],
	"./ArrowDownCircleBold.svg": [
		93322,
		93322
	],
	"./ArrowDownCircleRegular.svg": [
		6868,
		6868
	],
	"./ArrowDownLeftBold.svg": [
		7403,
		7403
	],
	"./ArrowDownLeftRegular.svg": [
		53530,
		53530
	],
	"./ArrowDownRegular.svg": [
		93852,
		93852
	],
	"./ArrowDownRightBold.svg": [
		87097,
		87097
	],
	"./ArrowDownRightRegular.svg": [
		8084,
		8084
	],
	"./ArrowLeftBold.svg": [
		1002,
		1002
	],
	"./ArrowLeftCircleBold.svg": [
		9140,
		9140
	],
	"./ArrowLeftCircleRegular.svg": [
		86866,
		86866
	],
	"./ArrowLeftDownCircleBold.svg": [
		92353,
		92353
	],
	"./ArrowLeftDownCircleRegular.svg": [
		95158,
		95158
	],
	"./ArrowLeftRegular.svg": [
		40729,
		40729
	],
	"./ArrowLeftUpCircleBold.svg": [
		78177,
		78177
	],
	"./ArrowLeftUpCircleRegular.svg": [
		42956,
		27185
	],
	"./ArrowRightBold.svg": [
		87977,
		87977
	],
	"./ArrowRightCircleBold.svg": [
		16627,
		16627
	],
	"./ArrowRightCircleRegular.svg": [
		50794,
		50794
	],
	"./ArrowRightDownCircleBold.svg": [
		70585,
		70585
	],
	"./ArrowRightDownCircleRegular.svg": [
		1873,
		1873
	],
	"./ArrowRightRegular.svg": [
		49970,
		49970
	],
	"./ArrowRightUpCircleBold.svg": [
		21974,
		21974
	],
	"./ArrowRightUpCircleRegular.svg": [
		20060,
		20060
	],
	"./ArrowTrendingDownBold.svg": [
		10536,
		10536
	],
	"./ArrowTrendingDownRegular.svg": [
		19260,
		19260
	],
	"./ArrowTrendingUpBold.svg": [
		64599,
		64599
	],
	"./ArrowTrendingUpRegular.svg": [
		94481,
		47450
	],
	"./ArrowUpBold.svg": [
		30688,
		30688
	],
	"./ArrowUpCircleBold.svg": [
		62122,
		62122
	],
	"./ArrowUpCircleRegular.svg": [
		94639,
		94639
	],
	"./ArrowUpLeftBold.svg": [
		3617,
		3617
	],
	"./ArrowUpLeftRegular.svg": [
		17574,
		17574
	],
	"./ArrowUpRegular.svg": [
		53797,
		53797
	],
	"./ArrowUpRightBold.svg": [
		64926,
		64926
	],
	"./ArrowUpRightRegular.svg": [
		24401,
		24401
	],
	"./AtRegular.svg": [
		63942,
		63942
	],
	"./BadgeBold.svg": [
		73391,
		918
	],
	"./BadgeRegular.svg": [
		50499,
		50499
	],
	"./BagBold.svg": [
		15947,
		15947
	],
	"./BagCheckBold.svg": [
		73483,
		73483
	],
	"./BagCheckRegular.svg": [
		74536,
		74536
	],
	"./BagRegular.svg": [
		62618,
		62618
	],
	"./BankBold.svg": [
		80917,
		80917
	],
	"./BankRegular.svg": [
		17464,
		17464
	],
	"./BikeBold.svg": [
		39321,
		39321
	],
	"./BikeRegular.svg": [
		19239,
		19239
	],
	"./BillList1.svg": [
		98033,
		98033
	],
	"./Bolt2Bold.svg": [
		90632,
		90632
	],
	"./Bolt2Regular.svg": [
		17093,
		17093
	],
	"./Bookmark1Bold.svg": [
		78458,
		78458
	],
	"./Bookmark1Regular.svg": [
		95846,
		95846
	],
	"./Bookmark2Bold.svg": [
		41069,
		41069
	],
	"./Bookmark2Regular.svg": [
		5688,
		5688
	],
	"./BuildingBold.svg": [
		94730,
		94730
	],
	"./BuildingRegular.svg": [
		49969,
		49969
	],
	"./BulbBold.svg": [
		99122,
		99122
	],
	"./BulbRegular.svg": [
		48952,
		48952
	],
	"./BurgerMenuBold.svg": [
		38864,
		38864
	],
	"./BurgerMenuRegular.svg": [
		51629,
		51629
	],
	"./CalculatorBold.svg": [
		64816,
		64816
	],
	"./CalculatorRegular.svg": [
		51358,
		51358
	],
	"./CalenderBold.svg": [
		8980,
		8980
	],
	"./CalenderRegular.svg": [
		95037,
		95037
	],
	"./CameraBold.svg": [
		63539,
		63539
	],
	"./CameraRegular.svg": [
		72642,
		72642
	],
	"./CancelCallBold.svg": [
		43936,
		43936
	],
	"./CancelCallRegular.svg": [
		17959,
		17959
	],
	"./CarAddBold.svg": [
		76478,
		76478
	],
	"./CarAddRegular.svg": [
		40423,
		40423
	],
	"./CarBold.svg": [
		24182,
		24182
	],
	"./CarFilledBold.svg": [
		25326,
		25326
	],
	"./CarFilledRegular.svg": [
		42025,
		42025
	],
	"./CarMinusBold.svg": [
		24933,
		24933
	],
	"./CarMinusRegular.svg": [
		63424,
		63424
	],
	"./CarRegular.svg": [
		77246,
		77246
	],
	"./CardBold.svg": [
		10371,
		10371
	],
	"./CardRegular.svg": [
		19880,
		19880
	],
	"./CartBold.svg": [
		49793,
		49793
	],
	"./CartRegular.svg": [
		85531,
		85531
	],
	"./CashBold.svg": [
		29262,
		29262
	],
	"./CashRegular.svg": [
		77343,
		77343
	],
	"./CertificateBold.svg": [
		10681,
		10681
	],
	"./CertificateRegular.svg": [
		44648,
		44648
	],
	"./ChatBubbleBold.svg": [
		92785,
		92785
	],
	"./ChatBubbleDotsBold.svg": [
		62024,
		62024
	],
	"./ChatBubbleDotsRegular.svg": [
		3524,
		3524
	],
	"./ChatBubbleGroupBold.svg": [
		50942,
		50942
	],
	"./ChatBubbleGroupRegular.svg": [
		48379,
		48379
	],
	"./ChatBubbleLikeBold.svg": [
		42605,
		42605
	],
	"./ChatBubbleLikeRegular.svg": [
		91463,
		91463
	],
	"./ChatBubbleReadBold.svg": [
		63673,
		63673
	],
	"./ChatBubbleReadRegular.svg": [
		96734,
		96734
	],
	"./ChatBubbleRegular.svg": [
		57214,
		57214
	],
	"./CheckCircleBold.svg": [
		11513,
		11513
	],
	"./CheckCircleRegular.svg": [
		98903,
		98903
	],
	"./CheckSquareBold.svg": [
		77592,
		77592
	],
	"./CheckSquareRegular.svg": [
		43375,
		43375
	],
	"./ChevronDownBold.svg": [
		9612,
		9612
	],
	"./ChevronDownRegular.svg": [
		42786,
		42786
	],
	"./ChevronLeftBold.svg": [
		46976,
		46976
	],
	"./ChevronLeftRegular.svg": [
		92236,
		92236
	],
	"./ChevronRightBold.svg": [
		16709,
		16709
	],
	"./ChevronRightRegular.svg": [
		3721,
		3721
	],
	"./ChevronUpBold.svg": [
		2656,
		2656
	],
	"./ChevronUpRegular.svg": [
		35768,
		35768
	],
	"./CityBold.svg": [
		87181,
		87181
	],
	"./CityRegular.svg": [
		76422,
		76422
	],
	"./ClockBold.svg": [
		46730,
		46730
	],
	"./ClockRegular.svg": [
		72256,
		72256
	],
	"./CloseSquareBold.svg": [
		92045,
		92045
	],
	"./CloseSquareRegular.svg": [
		15749,
		15749
	],
	"./CompassBold.svg": [
		39628,
		39628
	],
	"./CompassRegular.svg": [
		85405,
		85405
	],
	"./ConfettiBold.svg": [
		41940,
		41940
	],
	"./ContactsBold.svg": [
		41465,
		41465
	],
	"./ContactsRegular.svg": [
		27731,
		27731
	],
	"./CopyBold.svg": [
		99963,
		99963
	],
	"./CopyRegular.svg": [
		62988,
		62988
	],
	"./CrossBold.svg": [
		51053,
		51053
	],
	"./CrossCircleBold.svg": [
		72990,
		72990
	],
	"./CrossCircleRegular.svg": [
		62994,
		62994
	],
	"./CrossRegular.svg": [
		3434,
		3434
	],
	"./CrownBold.svg": [
		36678,
		36678
	],
	"./CrownRegular.svg": [
		40072,
		40072
	],
	"./CupStarRegular.svg": [
		2427,
		2427
	],
	"./DecoratedArrow.svg": [
		97608,
		97608
	],
	"./DirectionBold.svg": [
		47507,
		47507
	],
	"./DirectionRegular.svg": [
		73502,
		73502
	],
	"./DiscountBold.svg": [
		82237,
		82237
	],
	"./DocumentBold.svg": [
		37618,
		37618
	],
	"./Dot.svg": [
		42947,
		42947
	],
	"./DoubleTickBold.svg": [
		39496,
		39496
	],
	"./DoubleTickRegular.svg": [
		19121,
		19121
	],
	"./DownloadBold.svg": [
		66137,
		66137
	],
	"./DownloadRegular.svg": [
		12825,
		12825
	],
	"./DropBold.svg": [
		48272,
		48272
	],
	"./Edit2Bold.svg": [
		11229,
		11229
	],
	"./Edit2Regular.svg": [
		69003,
		69003
	],
	"./EditBold.svg": [
		14617,
		14617
	],
	"./EditRegular.svg": [
		389,
		389
	],
	"./EssentialsBold.svg": [
		10417,
		10417
	],
	"./EssentialsRegular.svg": [
		78902,
		78902
	],
	"./ExclaimationCircleBold.svg": [
		79894,
		79894
	],
	"./ExclaimationCircleRegular.svg": [
		38010,
		38010
	],
	"./EyeBold.svg": [
		53055,
		53055
	],
	"./EyeClosedBold.svg": [
		680,
		680
	],
	"./EyeClosedRegular.svg": [
		36498,
		36498
	],
	"./EyeRegular.svg": [
		58914,
		58914
	],
	"./FileAddBold.svg": [
		27350,
		27350
	],
	"./FileAddRegular.svg": [
		2256,
		2256
	],
	"./FileBold.svg": [
		38604,
		38604
	],
	"./FileCheckBold.svg": [
		39872,
		39872
	],
	"./FileCheckRegular.svg": [
		38258,
		94245
	],
	"./FileLockedBold.svg": [
		10647,
		10647
	],
	"./FileLockedRegular.svg": [
		22186,
		22186
	],
	"./FilePdfBold.svg": [
		52115,
		52115
	],
	"./FilePdfRegular.svg": [
		11003,
		11003
	],
	"./FileRegular.svg": [
		20298,
		20298
	],
	"./FileRemoveBold.svg": [
		97908,
		97908
	],
	"./FileRemoveRegular.svg": [
		25186,
		25186
	],
	"./FileWarningBold.svg": [
		23853,
		23853
	],
	"./FileWarningRegular.svg": [
		37817,
		37817
	],
	"./FilterBold.svg": [
		46129,
		46129
	],
	"./FilterRegular.svg": [
		81867,
		81867
	],
	"./Flag2Bold.svg": [
		58430,
		58430
	],
	"./Flag2Regular.svg": [
		44604,
		44604
	],
	"./FlagBold.svg": [
		9804,
		9804
	],
	"./FlagRegular.svg": [
		89270,
		89270
	],
	"./FlashBold.svg": [
		59698,
		59698
	],
	"./FlashRegular.svg": [
		47039,
		47039
	],
	"./FolderBold.svg": [
		95519,
		95519
	],
	"./FolderRegular.svg": [
		77687,
		77687
	],
	"./FoodBold.svg": [
		83667,
		83667
	],
	"./FoodRegular.svg": [
		27949,
		27949
	],
	"./FuelDrop.svg": [
		86740,
		86740
	],
	"./FuelMeterBold.svg": [
		44696,
		44696
	],
	"./FuelMeterRegular.svg": [
		60942,
		60942
	],
	"./FuelStationBold.svg": [
		29249,
		29249
	],
	"./FuelStationRegular.svg": [
		83553,
		83553
	],
	"./GPS.svg": [
		22903,
		22903
	],
	"./GarageBold.svg": [
		36731,
		36731
	],
	"./GarageRegular.svg": [
		543,
		543
	],
	"./GateBold.svg": [
		47830,
		47830
	],
	"./GateRegular.svg": [
		26570,
		26570
	],
	"./GiftBold.svg": [
		15071,
		15071
	],
	"./GiftRegular.svg": [
		39213,
		39213
	],
	"./GiftTopBold.svg": [
		94531,
		94531
	],
	"./GiftTopRegular.svg": [
		60315,
		60315
	],
	"./GlobeBold.svg": [
		36501,
		36501
	],
	"./GlobeRegular.svg": [
		31300,
		31300
	],
	"./HeadphoneRegular.svg": [
		33450,
		33450
	],
	"./HeartBold.svg": [
		85454,
		85454
	],
	"./HeartRegular.svg": [
		52874,
		52874
	],
	"./HelpAndSupportBold.svg": [
		38745,
		38745
	],
	"./HelpAndSupportRegular.svg": [
		41744,
		41744
	],
	"./HistoryBold.svg": [
		89769,
		89769
	],
	"./HistoryRegular.svg": [
		41462,
		41462
	],
	"./HomeBold.svg": [
		22276,
		22276
	],
	"./HomeRegular.svg": [
		52149,
		52149
	],
	"./ImageBold.svg": [
		51505,
		51505
	],
	"./ImageRegular.svg": [
		41189,
		41189
	],
	"./IncomingCallBold.svg": [
		49266,
		49266
	],
	"./IncomingCallRegular.svg": [
		32603,
		32603
	],
	"./IndiaLetters.svg": [
		311,
		311
	],
	"./Info2CircleBold.svg": [
		67250,
		67250
	],
	"./Info2CircleRegular.svg": [
		42862,
		42862
	],
	"./InfoCircleBold.svg": [
		14875,
		94481
	],
	"./InfoCircleRegular.svg": [
		6751,
		6751
	],
	"./KebabMenuBold.svg": [
		26593,
		26593
	],
	"./KebabMenuRegular.svg": [
		72714,
		72714
	],
	"./KeyBold.svg": [
		49670,
		49670
	],
	"./KeyRegular.svg": [
		89956,
		89956
	],
	"./LikeBold.svg": [
		12997,
		12997
	],
	"./Link1Bold.svg": [
		53496,
		53496
	],
	"./Link1Regular.svg": [
		99610,
		99610
	],
	"./ListRegular.svg": [
		28855,
		28855
	],
	"./LocationBold.svg": [
		23516,
		23516
	],
	"./LocationRegular.svg": [
		56351,
		56351
	],
	"./LockBold.svg": [
		85420,
		85420
	],
	"./LockOpenBold.svg": [
		85275,
		85275
	],
	"./LockOpenRegular.svg": [
		74913,
		74913
	],
	"./LockRegular.svg": [
		45086,
		45086
	],
	"./LogoutRegular.svg": [
		97535,
		97535
	],
	"./LogoutRightBold.svg": [
		62421,
		62421
	],
	"./LogoutRightRegular.svg": [
		98755,
		98755
	],
	"./LongArrowDownBold.svg": [
		53065,
		53065
	],
	"./LongArrowDownRegular.svg": [
		9675,
		9675
	],
	"./LongArrowLeftBold.svg": [
		19809,
		19809
	],
	"./LongArrowLeftRegular.svg": [
		48337,
		48337
	],
	"./LongArrowRightBold.svg": [
		25941,
		25941
	],
	"./LongArrowRightRegular.svg": [
		6006,
		6006
	],
	"./LongArrowUpBold.svg": [
		97547,
		97547
	],
	"./LongArrowUpRegular.svg": [
		53953,
		53953
	],
	"./MailBold.svg": [
		36010,
		36010
	],
	"./MailOpenBold.svg": [
		88661,
		88661
	],
	"./MailOpenRegular.svg": [
		22914,
		22914
	],
	"./MailRegular.svg": [
		99718,
		99718
	],
	"./MeatballMenuBold.svg": [
		69889,
		69889
	],
	"./MeatballMenuCircleBold.svg": [
		94549,
		94549
	],
	"./MeatballMenuCircleRegular.svg": [
		16403,
		16403
	],
	"./MeatballMenuRegular.svg": [
		83770,
		83770
	],
	"./MedalStarBold.svg": [
		20464,
		20464
	],
	"./MedalStarRegular.svg": [
		29349,
		29349
	],
	"./MegaPhone.svg": [
		68149,
		68149
	],
	"./MessageBold.svg": [
		16633,
		16633
	],
	"./MessageDotsBold.svg": [
		28905,
		28905
	],
	"./MessageDotsRegular.svg": [
		6437,
		6437
	],
	"./MessageGroupBold.svg": [
		80206,
		80206
	],
	"./MessageGroupRegular.svg": [
		73307,
		73307
	],
	"./MessageLikeBold.svg": [
		99355,
		99355
	],
	"./MessageLikeRegular.svg": [
		33843,
		33843
	],
	"./MessageReadBold.svg": [
		54687,
		54687
	],
	"./MessageReadRegular.svg": [
		29387,
		29387
	],
	"./MessageRegular.svg": [
		29119,
		29119
	],
	"./MicrophoneBold.svg": [
		32880,
		32880
	],
	"./MicrophoneRegular.svg": [
		6094,
		6094
	],
	"./MinuBold.svg": [
		63178,
		63178
	],
	"./MinuRegular.svg": [
		63816,
		63816
	],
	"./MinusCircleBold.svg": [
		69510,
		69510
	],
	"./MinusCircleRegular.svg": [
		84761,
		84761
	],
	"./MinusSquareBold.svg": [
		59484,
		59484
	],
	"./MinusSquareRegular.svg": [
		83730,
		83730
	],
	"./NavigateBold.svg": [
		35679,
		35679
	],
	"./NavigateRegular.svg": [
		91835,
		91835
	],
	"./NotebookBold.svg": [
		22359,
		22359
	],
	"./NotebookRegular.svg": [
		70763,
		70763
	],
	"./NotificationBold.svg": [
		18735,
		18735
	],
	"./NotificationRegular.svg": [
		24008,
		24008
	],
	"./NotificationSilentBold.svg": [
		70251,
		70251
	],
	"./NotificationSilentRegular.svg": [
		32884,
		32884
	],
	"./NotificationTickBold.svg": [
		15225,
		15225
	],
	"./NotificationTickRegular.svg": [
		45107,
		45107
	],
	"./NounLimit.svg": [
		25894,
		25894
	],
	"./Offer2Bold.svg": [
		20400,
		20400
	],
	"./Offer2Regular.svg": [
		25174,
		25174
	],
	"./OfferBold.svg": [
		70892,
		70892
	],
	"./OfferRegular.svg": [
		29142,
		29142
	],
	"./PaperclipBold.svg": [
		63087,
		63087
	],
	"./PaperclipRegular.svg": [
		64292,
		64292
	],
	"./Park+VerifiedBold.svg": [
		31691,
		31691
	],
	"./Park+VerifiedRegular.svg": [
		6211,
		6211
	],
	"./ParkVerifiedBold.svg": [
		80699,
		80699
	],
	"./ParkVerifiedRegular.svg": [
		23762,
		23762
	],
	"./PauseBold.svg": [
		54878,
		54878
	],
	"./PauseRegular.svg": [
		6514,
		6514
	],
	"./PercentageBold.svg": [
		74250,
		74250
	],
	"./PercentageRegular.svg": [
		73901,
		73901
	],
	"./PhoneBold.svg": [
		75463,
		75463
	],
	"./PhoneCallingBold.svg": [
		21958,
		21958
	],
	"./PhoneCallingRegular.svg": [
		94722,
		94722
	],
	"./PhoneRegular.svg": [
		63691,
		63691
	],
	"./PlayBold.svg": [
		78035,
		78035
	],
	"./PlayRegular.svg": [
		54169,
		54169
	],
	"./PlusBold.svg": [
		25784,
		25784
	],
	"./PlusCircleBold.svg": [
		80026,
		80026
	],
	"./PlusCircleRegular.svg": [
		92057,
		92057
	],
	"./PlusRegular.svg": [
		44456,
		44456
	],
	"./QrCodeBold.svg": [
		16151,
		16151
	],
	"./QrCodeRegular.svg": [
		18519,
		18519
	],
	"./QuestionCircleBold.svg": [
		21326,
		21326
	],
	"./QuestionCircleRegular.svg": [
		12784,
		12784
	],
	"./RefreshBold.svg": [
		96324,
		96324
	],
	"./RefreshRegular.svg": [
		80519,
		80519
	],
	"./RestartBold.svg": [
		2210,
		2210
	],
	"./RestartRegular.svg": [
		79072,
		79072
	],
	"./RestrictBold.svg": [
		79668,
		79668
	],
	"./RestrictRegular.svg": [
		60742,
		60742
	],
	"./RevokeBold.svg": [
		66375,
		66375
	],
	"./RevokeRegular.svg": [
		47368,
		47368
	],
	"./RocketBold.svg": [
		21930,
		21930
	],
	"./RocketRegular.svg": [
		36283,
		36283
	],
	"./RoundDownArrowCircleBold.svg": [
		97515,
		83405
	],
	"./RoundDownArrowCircleRegular.svg": [
		16494,
		16494
	],
	"./RoundLeftArrowCircleBold.svg": [
		99756,
		99756
	],
	"./RoundLeftArrowCircleRegular.svg": [
		29103,
		29103
	],
	"./RoundRightArrowCircleBold.svg": [
		30178,
		30178
	],
	"./RoundRightArrowCircleRegular.svg": [
		92493,
		92493
	],
	"./RoundUpArrowCircleBold.svg": [
		42248,
		42248
	],
	"./RoundUpArrowCircleRegular.svg": [
		71673,
		71673
	],
	"./RoutingBold.svg": [
		72605,
		72605
	],
	"./RupeeBold.svg": [
		86687,
		86687
	],
	"./RupeeRegular.svg": [
		16394,
		16394
	],
	"./SearchBold.svg": [
		61090,
		61090
	],
	"./SearchCircleBold.svg": [
		73041,
		73041
	],
	"./SearchCircleRegular.svg": [
		11774,
		11774
	],
	"./SearchRegular.svg": [
		45014,
		45014
	],
	"./SecurityScanner.svg": [
		87246,
		87246
	],
	"./SendBold.svg": [
		73507,
		73507
	],
	"./SendRegular.svg": [
		29762,
		29762
	],
	"./SettingsBold.svg": [
		83549,
		83549
	],
	"./SettingsRegular.svg": [
		88190,
		97559
	],
	"./Share1Bold.svg": [
		17232,
		17232
	],
	"./Share1Regular.svg": [
		85374,
		85374
	],
	"./ShareBold.svg": [
		22661,
		63253
	],
	"./ShareMultipleBold.svg": [
		72490,
		72490
	],
	"./ShareMultipleRegular.svg": [
		6941,
		6941
	],
	"./ShareRegular.svg": [
		44443,
		44443
	],
	"./ShieldBold.svg": [
		71181,
		71181
	],
	"./ShieldCheckBold.svg": [
		58350,
		58350
	],
	"./ShieldCheckRegular.svg": [
		73514,
		73514
	],
	"./ShieldCrossBold.svg": [
		16916,
		16916
	],
	"./ShieldCrossRegular.svg": [
		41094,
		41094
	],
	"./ShieldRegular.svg": [
		71417,
		71417
	],
	"./ShieldUserBold.svg": [
		55616,
		55616
	],
	"./ShieldUserRegular.svg": [
		8094,
		8094
	],
	"./ShieldWarningBold.svg": [
		51033,
		51033
	],
	"./ShieldWarningRegular.svg": [
		60220,
		60220
	],
	"./Shop1Bold.svg": [
		23946,
		23946
	],
	"./Shop1Regular.svg": [
		8068,
		8068
	],
	"./Shop2Bold.svg": [
		21144,
		21144
	],
	"./Shop2Regular.svg": [
		6491,
		6491
	],
	"./SortHorizontalBold.svg": [
		78294,
		78294
	],
	"./SortHorizontalRegular.svg": [
		31729,
		31729
	],
	"./SortVerticleBold.svg": [
		80914,
		80914
	],
	"./SortVerticleRegular.svg": [
		56545,
		56545
	],
	"./SpeedometerBold.svg": [
		79378,
		79378
	],
	"./SpeedometerRegular.svg": [
		63613,
		63613
	],
	"./StackBold.svg": [
		19258,
		19258
	],
	"./StackRegular.svg": [
		23518,
		23518
	],
	"./StarBold.svg": [
		19103,
		19103
	],
	"./StarCircleBold.svg": [
		76874,
		76874
	],
	"./StarCircleRegular.svg": [
		6273,
		6273
	],
	"./StarRegular.svg": [
		52988,
		52988
	],
	"./StarsBold.svg": [
		97787,
		97787
	],
	"./StarsInCircle.svg": [
		35834,
		35834
	],
	"./StarsRegular.svg": [
		93004,
		93004
	],
	"./SteeringBold.svg": [
		5157,
		5157
	],
	"./SteeringRegular.svg": [
		71392,
		71392
	],
	"./ThumbsUpBold.svg": [
		25100,
		25100
	],
	"./ThumbsUpRegular.svg": [
		25778,
		25778
	],
	"./TickBold.svg": [
		68228,
		68228
	],
	"./TickCircleBold.svg": [
		17397,
		17397
	],
	"./TickCircleRegular.svg": [
		15622,
		15622
	],
	"./TickRegular.svg": [
		39634,
		39634
	],
	"./TicketBold.svg": [
		49491,
		49491
	],
	"./TicketRegular.svg": [
		6180,
		6180
	],
	"./ToolBold.svg": [
		45336,
		45336
	],
	"./ToolRegular.svg": [
		60075,
		60075
	],
	"./TrashBold.svg": [
		15593,
		15593
	],
	"./TrashRegular.svg": [
		43449,
		43449
	],
	"./TrophyFirstBold.svg": [
		49239,
		49239
	],
	"./TrophyFirstRegular.svg": [
		41383,
		41383
	],
	"./TrophyStarBold.svg": [
		85607,
		85607
	],
	"./TrophyStarRegular.svg": [
		95595,
		95595
	],
	"./TruckBold.svg": [
		74980,
		74980
	],
	"./TruckRegular.svg": [
		48101,
		48101
	],
	"./UnlikeBold.svg": [
		26701,
		26701
	],
	"./UnlikeRegular.svg": [
		53193,
		53193
	],
	"./UpiBold.svg": [
		29574,
		87186
	],
	"./UpiRegular.svg": [
		33403,
		33403
	],
	"./UploadBold.svg": [
		73372,
		73372
	],
	"./UploadRegular.svg": [
		31543,
		31543
	],
	"./UserAddBold.svg": [
		34594,
		34594
	],
	"./UserAddRegular.svg": [
		23942,
		23942
	],
	"./UserBlock.svg": [
		25358,
		25358
	],
	"./UserBold.svg": [
		54057,
		54057
	],
	"./UserCheckBold.svg": [
		57602,
		57602
	],
	"./UserGroup1Bold.svg": [
		4379,
		4379
	],
	"./UserGroup1Regular.svg": [
		74910,
		74910
	],
	"./UserGroup2Bold.svg": [
		90886,
		90886
	],
	"./UserGroup2Regular.svg": [
		75154,
		75154
	],
	"./UserIdBold.svg": [
		70949,
		70949
	],
	"./UserIdRegular.svg": [
		11080,
		11080
	],
	"./UserProfileBold.svg": [
		41442,
		41442
	],
	"./UserProfileRegular.svg": [
		86991,
		86991
	],
	"./UserRegular.svg": [
		24082,
		24082
	],
	"./UserSyncBold.svg": [
		28134,
		28134
	],
	"./UserSyncRegular.svg": [
		15818,
		15818
	],
	"./UserVerifiedCircleBold.svg": [
		96137,
		96137
	],
	"./UserVerifiedCircleRegular.svg": [
		22236,
		22236
	],
	"./VerifiedCheckBold.svg": [
		58962,
		58962
	],
	"./VerifiedCheckRegular.svg": [
		15635,
		15635
	],
	"./VideoBold.svg": [
		60140,
		60140
	],
	"./VideoRegular.svg": [
		16115,
		16115
	],
	"./VolumeBold.svg": [
		62600,
		62600
	],
	"./VolumeOffBold.svg": [
		15192,
		15192
	],
	"./VolumeOffRegular.svg": [
		92756,
		92756
	],
	"./VolumeRegular.svg": [
		62530,
		62530
	],
	"./Whatsapp.svg": [
		37916,
		37916
	],
	"./WhatsappIcon.svg": [
		1603,
		1603
	],
	"./WidgetAddBold.svg": [
		28121,
		28121
	],
	"./WidgetAddRegular.svg": [
		69832,
		85355
	],
	"./WidgetBold.svg": [
		35143,
		35143
	],
	"./WidgetRegular.svg": [
		79674,
		79674
	],
	"./XtraRewards.svg": [
		13897,
		13897
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 69676;
module.exports = webpackAsyncContext;